import React, { useEffect, useState } from 'react'
import pubsub from "@viewlift/pubsub"
import { validateSubscriptionOfferCodeByPlanId } from '../Stripe/Api'
import { addPaymentInfo, getActualPrice } from '../helper'
import { publishAppLoading, publishErrorUpdate, publishNotificationUpdate } from '../../Events/utils.events'
import { publishIsActive } from '../../Events/plans.events'
import { fetchCurrentPlan, structuredPlan } from '../../PlansWrapper/helper'
import { handleStatusGaCalls } from '../../../helpers'
import logger from '../../../logger';
const OfferCode = ({ metadataMap, moduleData, isUpgrade='', isDisabled }) => {
    
    const [validating, setValidating] = useState(false)
    const [offerCodeDetails, setOfferCodeDetails] = useState({})
    const [offer, setOfferCode] = useState(null)

    const checkForParamsOffer = () => {
        const params = new URLSearchParams(window.location.search)
        const paramOffer = params.get('offer')
        if (paramOffer && !isUpgrade) onClickApply()
    }

    useEffect(() => {
        checkForParamsOffer()
        publishAppLoading(false)
    }, [])

    const onClickApply = async (e,data) => {
        try 
        {
            e?.stopPropagation()
            e?.preventDefault()
            let currentPlan = fetchCurrentPlan()
            if (data) {
                if (currentPlan?.planId !== data?.offerPlan?.id) {
                    let plan = structuredPlan(data?.offerPlan,currentPlan?.subscriptionPopupFonts)
                    let planDetails = {
                        id: plan?.planId,
                        features: plan?.features
                    }
                    sessionStorage.setItem('currentPlan',JSON.stringify(plan))
                    currentPlan = plan
                    publishIsActive({ planDetails, selectedPlanId: plan?.planId, plan })
                }
            }
            setValidating(true)
            const params = new URLSearchParams(window.location.search)
            const paramOffer = params.get('offer')
            let offerCode = paramOffer || (e?.target && e?.target?.value?.toUpperCase()) || offer?.toUpperCase() || data?.promocode
            sessionStorage.setItem('offerCode', offerCode)
            let planId = currentPlan.planId || currentPlan?.id
            if (!offerCodeDetails) {
                setValidating(false)
                pubsub.publish('isLoading', false)
                return false
            }
            const offerValidatePayload = {
                offerCode: offerCode,
                subscriptionPlanId: planId,
                site: window?.app_data?.site?.siteInternalName,
            }
            handleStatusGaCalls({eventName : 'apply_code_status', type : 'apply-code', reason : offerCode, status : 'initiate', action : 'Apply Promo Code', paymentStatus : null,eventCategory : 'Payment',section : 'checkout', method: 'Razorpay'})
            let validateOfferResponse = await validateSubscriptionOfferCodeByPlanId(offerValidatePayload)
            if (!validateOfferResponse.isError) {
                let offerCodeAnalyticsData = {
                    "promotionCode": validateOfferResponse?.data?.id,
                    "offerName": validateOfferResponse?.data?.name,
                    "offerType": validateOfferResponse?.data?.offerDetails?.offerStrategyType,
                    "offerAdd": 'Manual'
                }
                setValidating(false)
                let offerCodeMessage = metadataMap?.offerCodeAppliedText?.replace("$VIEWLIFT_OFFERCODER", offerCode)
                publishNotificationUpdate({message : offerCodeMessage || 'Promo Code Applied', type : "OFFER"})
                setOfferCodeDetails({
                    displayName: validateOfferResponse.data.displayName,
                    name: validateOfferResponse.data.name,
                    code: offerCode
                })
                setOfferCode(offerCode)
                getActualPrice(offerCodeAnalyticsData)
                addPaymentInfo(currentPlan,{
                    displayName: validateOfferResponse.data.displayName,
                    name: validateOfferResponse.data.name,
                    code: offerCode
                })

                handleStatusGaCalls({eventName : 'apply_code_status', type : 'apply-code', reason : offerCode, status : 'success', action : 'Apply Promo Code', paymentStatus : null,eventCategory : 'Payment',section : 'checkout', method: 'Razorpay'})
                handleStatusGaCalls({eventName : 'select_promotion', type : 'apply-code', reason : offerCode, status : 'success', action : 'Apply Promo Code', paymentStatus : null,eventCategory : 'Payment',section : 'checkout', paymentHandler: 'Razorpay'})
            }
            if (validateOfferResponse.isError) {
                setValidating(false)   
                pubsub.publish('isLoading', false)
                sessionStorage.removeItem('offerCode')
                logger(validateOfferResponse)
                publishErrorUpdate(metadataMap?.promoValidatingError || 'Invalid Promo Code')
                handleStatusGaCalls({eventName : 'apply_code_status', type : 'apply-code', reason : offerCode, status : 'failure', action : 'Apply Promo Code', paymentStatus : null,eventCategory : 'Payment',section : 'checkout', paymentHandler: 'Razorpay'})
                handleStatusGaCalls({eventName : 'select_promotion', type : 'apply-code', reason : offerCode, status : 'failure', action : 'Apply Promo Code', paymentStatus : null,eventCategory : 'Payment',section : 'checkout', paymentHandler: 'Razorpay'})
            }
        } catch (error) {
            setValidating(false);
            pubsub.publish('isLoading', false);
            logger(error);
            publishErrorUpdate('An error occurred while applying the promo code');
        }
    }
    const removeCode = () => {
        sessionStorage.removeItem('offerCode')
        setOfferCodeDetails({})
        setOfferCode("")
        getActualPrice()
    }

    return (
        <div className='offer-code-wrapper'>
            <div style={isDisabled ? { pointerEvents: "none" } : {}}>
               
                <div className='offer-container'>
                    <div className='heading-text'>{metadataMap?.offerCodeLabel || 'Offer Code'}</div>
                    <div className='coupon-input'>
                        <input
                            aria-labelledby={metadataMap?.addPromoPlaceholder || 'Add Promo'}
                            className={`offer-code-input ${Object.keys(offerCodeDetails).length > 0 ? "applied-code" : ""}`}
                            placeholder={metadataMap?.addPromoPlaceholder || 'Add Promo'}
                            onChange={(e) => {
                                    setOfferCode(e.target.value)
                                    let applyCodeBtn = document.querySelector(".apply")
                                    if (e.target.value) {
                                        applyCodeBtn.style.background = moduleData?.layout?.settings?.activeCTAColor
                                    }
                                }
                            }
                            onKeyPress={e => { if (e.key === 'Enter' && offer) onClickApply(e) }}
                            value={offer}
                        />
                        {Object.keys(offerCodeDetails).length > 0 &&
                            <button
                                aria-label="cancel"
                                className="remove-code-btn  site-cta-color site-cta-background-color "
                                onClick={() => { removeCode()}}>
                                {metadataMap?.cancelPromo || 'Cancel'}
                            </button>
                        }
                        {Object.keys(offerCodeDetails).length == 0 && <button
                            disabled={!offer}
                            aria-label="apply"
                            className={`apply offer-code-button ${isDisabled ? 'disabled-button' : 'active-button'} ${validating ? ' processing' : ''}`}
                            onClick={(e) => onClickApply(e)}>
                            {validating ? metadataMap?.processingTxt || 'Processing' : metadataMap?.applyCode || 'Apply'}
                        </button>}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OfferCode